/**
 * MobileMenu — Enhances WordPress block navigation overlay.
 *
 * Injects a logo and Contact CTA button into the responsive
 * container so the mobile menu feels complete and branded.
 *
 * @module MobileMenu
 */
export default class MobileMenu {

  static DEFAULTS = {
    containerSelector: '.wp-block-navigation__responsive-container',
    contentSelector: '.wp-block-navigation__responsive-container-content',
    dialogSelector: '.wp-block-navigation__responsive-dialog',
    logoSrc: '/wp-content/themes/westcode-by-leb/assets/images/logo-turquoise.png',
    contactUrl: '/contact',
  };

  constructor() {
    this.container = document.querySelector(MobileMenu.DEFAULTS.containerSelector);
    if (!this.container) return;
    this._inject();
  }

  _inject() {
    const dialog = this.container.querySelector(MobileMenu.DEFAULTS.dialogSelector);
    const content = this.container.querySelector(MobileMenu.DEFAULTS.contentSelector);
    if (!dialog || !content) return;

    // Logo — top of overlay
    if (!dialog.querySelector('.wleb-mobile-logo')) {
      const logo = document.createElement('a');
      logo.href = '/';
      logo.className = 'wleb-mobile-logo';
      logo.innerHTML = `<img src="${MobileMenu.DEFAULTS.logoSrc}" alt="Westcode by LEB" width="180">`;
      dialog.insertBefore(logo, content);
    }

    // CTA — bottom of overlay
    if (!dialog.querySelector('.wleb-mobile-cta')) {
      const cta = document.createElement('a');
      cta.href = MobileMenu.DEFAULTS.contactUrl;
      cta.className = 'wleb-mobile-cta';
      cta.textContent = 'Nous contacter';
      dialog.appendChild(cta);
    }

    // Accordion for submenus
    this._initAccordion(content);
  }

  /**
   * Accordion — adds chevron toggles to parent items with children.
   * Tap chevron → expand/collapse submenu (one open at a time).
   * Tap parent link → navigate normally.
   */
  _initAccordion(content) {
    const parents = content.querySelectorAll('.wp-block-navigation-item.has-child');
    if (!parents.length) return;

    const chevronSVG = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    parents.forEach((li) => {
      // Skip if already initialized
      if (li.querySelector('.wleb-submenu-toggle')) return;

      const btn = document.createElement('button');
      btn.className = 'wleb-submenu-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Ouvrir le sous-menu');
      btn.innerHTML = chevronSVG;

      // Insert after the parent link
      const link = li.querySelector(':scope > .wp-block-navigation-item__content');
      if (link) {
        link.after(btn);
      }

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = li.classList.contains('is-submenu-open');

        // Accordion: close all siblings first
        parents.forEach((sibling) => {
          sibling.classList.remove('is-submenu-open');
          const sibBtn = sibling.querySelector('.wleb-submenu-toggle');
          if (sibBtn) {
            sibBtn.setAttribute('aria-expanded', 'false');
            sibBtn.setAttribute('aria-label', 'Ouvrir le sous-menu');
          }
        });

        // Toggle current
        if (!isOpen) {
          li.classList.add('is-submenu-open');
          btn.setAttribute('aria-expanded', 'true');
          btn.setAttribute('aria-label', 'Fermer le sous-menu');
        }
      });
    });
  }

  destroy() {}
}
